import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { DateField, Field } from "@/components/common/Field";
import PicSelect from "@/components/common/PicSelect";
import ProductPicker from "@/components/common/ProductPicker";
import PhotoUploader from "@/components/common/PhotoUploader";
import { PrimaryBtn } from "@/components/common/ui";
import { FormShell } from "./ProductionForms";
import { api, errMsg } from "@/lib/api";
import { WASTE_REASONS } from "@/lib/format";

export default function WasteForm({ open, onClose, products, defaultDate, onSaved }) {
  const [date, setDate] = useState(defaultDate);
  const [productId, setProductId] = useState("");
  const [qty, setQty] = useState(1);
  const [pic, setPic] = useState("");
  const [reason, setReason] = useState("");
  const [other, setOther] = useState("");
  const [notes, setNotes] = useState("");
  const [photos, setPhotos] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (open) { setDate(defaultDate); setProductId(""); setQty(1); setReason(""); setOther(""); setNotes(""); setPhotos([]); }
  }, [open, defaultDate]);
  const p = products?.find((x) => x.id === productId);
  const valid = productId && Number(qty) > 0 && reason && (reason !== "Lainnya" || other.trim().length >= 3) && photos.length >= 1 && pic;

  const submit = async () => {
    setSaving(true);
    try {
      const { data } = await api.post("/waste", { date, product_id: productId, qty: Number(qty), pic_user_id: pic, reason, reason_other: other, notes, photo_ids: photos.map((f) => f.id) });
      toast.success(`Waste tercatat · ${data.txn_no}`);
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  return (
    <FormShell open={open} onClose={onClose} title="Buang ke Tong Sampah" testid="waste-form"
      desc="Semua kolom wajib. Foto bukti minimal 1 (anti-cheating). Setelah disimpan, Staff tidak bisa mengubah entri.">
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <DateField value={date} onChange={setDate} testid="waste-date" />
          <Field label={`Qty (${p?.stock_unit || "pcs"})`} required>
            <input type="number" min="1" inputMode="numeric" value={qty} onChange={(e) => setQty(e.target.value)} data-testid="waste-qty"
              className="num h-12 w-full rounded-md border border-zinc-300 px-3 text-lg font-bold focus:border-ink focus:outline-none" />
          </Field>
        </div>
        <Field label="Produk" required><ProductPicker products={products} value={productId} onChange={setProductId} filter={(x) => !x.is_bundle} testid="waste-product" showStock /></Field>
        <PicSelect value={pic} onChange={setPic} testid="waste-pic" />
        <Field label="Alasan" required>
          <Select value={reason} onValueChange={setReason}>
            <SelectTrigger className="h-12" data-testid="waste-reason"><SelectValue placeholder="Pilih alasan" /></SelectTrigger>
            <SelectContent>{WASTE_REASONS.map((r) => <SelectItem key={r} value={r} data-testid={`waste-reason-${r}`}>{r}</SelectItem>)}</SelectContent>
          </Select>
        </Field>
        {reason === "Lainnya" && <Field label="Alasan lainnya" required><Textarea value={other} onChange={(e) => setOther(e.target.value)} data-testid="waste-reason-other" /></Field>}
        <Field label="Foto bukti (1–5)" required><PhotoUploader value={photos} onChange={setPhotos} testid="waste-photos" /></Field>
        <Field label="Catatan"><Textarea value={notes} onChange={(e) => setNotes(e.target.value)} data-testid="waste-notes" /></Field>
        {!photos.length && <p className="text-xs font-semibold text-brand" data-testid="waste-photo-required">Foto bukti wajib sebelum menyimpan.</p>}
        <PrimaryBtn className="w-full" onClick={submit} disabled={!valid || saving} data-testid="waste-submit">{saving ? "Menyimpan…" : "Simpan Waste"}</PrimaryBtn>
      </div>
    </FormShell>
  );
}
